// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"dfad8606","169":"a8b7c1a6","229":"bd67797e","388":"34aaaf7d","489":"fa1ee85d","494":"3de888ff","835":"57d57658"}[chunkId] + ".chunk.css";
};